<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <div class="vm-search" style="height: 5vh;">
        <vm-search label="派工单号">
          <el-input ref="inputBillNo" v-model.trim="filter.billNo" placeholder="请扫描派工单" clearable
                    @keyup.enter.native="getData"/>
        </vm-search>
        <el-button
            type="primary"
            :loading="loading"
            size="mini"
            style="height: 26px; margin-left: 10px;"
            @click="getData">
          查询
        </el-button>
        <el-button
            type="primary"
            :loading="loading"
            size="mini"
            style="height: 26px; margin-left: 10px;"
            @click="clearData">
          清除
        </el-button>
      </div>
      <div>
        <el-button
            style="float: left;margin-top: 5px;"
            type="primary"
            @click="printCodeV2()">
          标签打印V2
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel1">
          电阻内盒铭牌(80*40)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel2">
          电阻内盒中性(80*40)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel2a1">
          电阻产品标(35*16)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel3">
          电阻箱产品标(80*40)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel3a0">
          电阻箱产品标(60*30)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel3a1">
          电阻箱产品标(50*25)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel6">
          电抗(60*30)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel6a1">
          电抗(50*25)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel6a4">
          远景(50*25)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel6a2">
          电抗(20*26)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel6a3">
          ATR(60*30)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel7">
          追溯码(25*11)
        </el-button>
        <el-button
            slot="append"
            style="margin-top: 5px;"
            type="primary"
            @click="printLabel8">
          客户条码(36*15)
        </el-button>
      </div>
      <el-table
          height="20vh"
          :data="tableData"
          style="width: 100%;margin-top: 10px;">
        <el-table-column prop="billNo" align="center" label="派工单号" width="120"/>
        <el-table-column prop="productionOrderNo" align="center" label="工单编号" width="100"/>
        <el-table-column prop="customerName" align="center" label="客户" width="120"/>
        <el-table-column prop="finalCustomerName" align="center" label="最终客户" width="100"/>
        <el-table-column prop="materialNo" align="center" label="物料编号" width="120"/>
        <el-table-column prop="materialName" align="center" label="物料描述" width="120"/>
        <el-table-column prop="specification" align="center" label="规格型号" width="120"/>
        <el-table-column prop="workCenterName" align="center" label="工作中心" width="120"/>
        <el-table-column prop="quantity" align="center" label="数量" width="80"/>
        <el-table-column prop="planStartTime" align="center" label="计划开工时间" width="100"/>
        <el-table-column prop="planFinishTime" align="center" label="计划完工时间" width="100"/>
        <el-table-column prop="deliveryDate" align="center" label="交货日期" width="100"/>
        <el-table-column prop="finalDeliveryDate" align="center" label="最终交期" width="100"/>
        <!--        <el-table-column prop="unitPrice" align="center" label="单价"/>-->
        <el-table-column prop="erpSalesOrderNo" align="center" label="销售订单号"/>
        <el-table-column prop="deliveryDate" align="center" label="要求交期" width="100"/>
        <el-table-column prop="salesOrderMaterialNote" align="center" label="订单备注" width="120"/>
      </el-table>
    </el-main>
    <material-code-modal3 ref="materialCodeModal3"/>
    <!--    标签-->
    <label-modal1 ref="labelModal1"/>
    <label-modal2 ref="labelModal2"/>
    <label-modal2a1 ref="labelModal2a1"/>
    <label-modal3 ref="labelModal3"/>
    <label-modal3a0 ref="labelModal3a0"/>
    <label-modal3a1 ref="labelModal3a1"/>
    <label-modal6 ref="labelModal6"/>
    <label-modal6a1 ref="labelModal6a1"/>
    <label-modal6a2 ref="labelModal6a2"/>
    <label-modal6a3 ref="labelModal6a3"/>
    <label-modal6a4 ref="labelModal6a4"/>
    <label-modal7 ref="labelModal7"/>
    <label-modal8 ref="labelModal8"/>
  </el-container>
</template>

<script>
  import VmSearch from "@/components/VmSearch.vue";
  import LabelModal1 from "@/views/ProductionManagement/ProductionTask/LabelModal1";
  import LabelModal2 from "@/views/ProductionManagement/ProductionTask/LabelModal2";
  import LabelModal2a1 from "@/views/ProductionManagement/ProductionTask/LabelModal2a1";
  import LabelModal3 from "@/views/ProductionManagement/ProductionTask/LabelModal3";
  import LabelModal3a0 from "@/views/ProductionManagement/ProductionTask/LabelModal3a0";
  import LabelModal3a1 from "@/views/ProductionManagement/ProductionTask/LabelModal3a1";
  import LabelModal6 from "@/views/ProductionManagement/ProductionTask/LabelModal6";
  import LabelModal6a1 from "@/views/ProductionManagement/ProductionTask/LabelModal6a1";
  import LabelModal6a2 from "@/views/ProductionManagement/ProductionTask/LabelModal6a2";
  import LabelModal6a3 from "@/views/ProductionManagement/ProductionTask/LabelModal6a3";
  import LabelModal6a4 from "@/views/ProductionManagement/ProductionTask/LabelModal6a4";
  import LabelModal7 from "@/views/ProductionManagement/ProductionTask/LabelModal7";
  import LabelModal8 from "@/views/ProductionManagement/ProductionTask/LabelModal8";
  import MaterialCodeModal3 from "@/views/ProductionManagement/ProductionOrder/MaterialCodeModal3";

  export default {
    name: "LabelPrintingPageTaskOrder",
    components: {
      VmSearch,
      MaterialCodeModal3,
      LabelModal1,
      LabelModal2,
      LabelModal2a1,
      LabelModal3,
      LabelModal3a0,
      LabelModal3a1,
      LabelModal6,
      LabelModal6a1,
      LabelModal6a2,
      LabelModal6a3,
      LabelModal6a4,
      LabelModal7,
      LabelModal8,
    },
    data() {
      return {
        loading: false,
        submitLoading: false,
        printLoading: false,
        loadingPrintCode: false,
        filter: {
          billNo: "",
        },
        tableData: [],
        selectedRow: {},
      };
    },
    methods: {
      clearData() {
        this.selectedRow = {};
        this.tableData = [];
        this.filter.billNo = "";
        this.$refs.inputBillNo.focus();
      },
      getData() {
        this.selectedRow = {};
        this.tableData = this.$options.data().tableData;
        if (!this.filter.billNo) {
          this.$message.error("请输入查询条件");
          return;
        }
        this.getList();
      },
      getList() {
        this.loading = true;
        let params = {
          "billNo": this.filter.billNo == null ? "" : this.filter.billNo,
        };
        this.$http
            .get("basic", "taskDispatchBills/barCode1", params)
            .then(resp => {
              this.loading = false;
              this.tableData = resp.data;
              if (this.tableData) {
                this.selectedRow = this.tableData[0];
              }
              this.filter.billNo = "";
              this.$refs.inputBillNo.focus();
            });

      },
      //内盒铭牌打印 80*40
      printLabel1() {
        this.$refs.labelModal1.open(this.selectedRow);
      },
      //内盒中性打印 80*40
      printLabel2() {
        this.$refs.labelModal2.open(this.selectedRow);
      },
      //电阻箱产品标 35*16
      printLabel2a1() {
        this.$refs.labelModal2a1.open(this.selectedRow);
      },
      //电阻箱产品标 80*40
      printLabel3() {
        this.$refs.labelModal3.open(this.selectedRow);
      },
      //电阻箱产品标 60*30
      printLabel3a0() {
        this.$refs.labelModal3a0.open(this.selectedRow);
      },
      //电阻箱产品标 50*25
      printLabel3a1() {
        this.$refs.labelModal3a1.open(this.selectedRow);
      },
      //电抗 60*30
      printLabel6() {
        this.$refs.labelModal6.open(this.selectedRow);
      },
      //电抗 50*25
      printLabel6a1() {
        this.$refs.labelModal6a1.open(this.selectedRow);
      },
      //远景 50*25
      printLabel6a4() {
        // this.$http.get("basic", `taskDispatchBills/${this.selection[0].pkid}`).then((res) => {
        //   if (res.success) {
        //     if (res.data.yjPrintTimes) {
        //       this.$refs.labelModal6a4.open(this.selection[0], res.data.yjPrintTimes);
        //     } else {
        //       this.$refs.labelModal6a4.open(this.selection[0], 0);
        //     }
        //   }
        // });

        this.$http.get("basic", "taskDispatchBills/getPrintNo").then((res) => {
          if (res.success) {
            if (res.data) {
              this.$refs.labelModal6a4.open(this.selection[0], res.data);
            } else {
              this.$refs.labelModal6a4.open(this.selection[0], 0);
            }
          }
        });
      },
      //电抗 20*26
      printLabel6a2() {
        this.$refs.labelModal6a2.open(this.selectedRow);
      },
      //ATR 60*30
      printLabel6a3() {
        this.$refs.labelModal6a3.open(this.selectedRow);
      },
      //追溯码 25*11
      printLabel7() {
        this.$refs.labelModal7.open(this.selectedRow);
      },
      //客户条码 36*15
      printLabel8() {
        this.$refs.labelModal8.open(this.selectedRow);
      },
      // 打印标签
      printCode() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selection[0].pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              // this.$refs.printProductionCard2.open(resp.data,productInfo);
              this.$refs.materialCodeModal.open(resp.data, this.selection[0]);
              // if (!resp.data[0].prodType) {
              //   this.$refs.materialCodeModal.open(resp.data, productInfo);
              // } else {
              //   productInfo.createTime = resp.data[0].prodTime;
              //   productInfo.finishQuantity = resp.data[0].quantity;
              //   productInfo.batchRowNo = resp.data[0].batchRowNo;
              //   this.$refs.printProductionCard.open(resp.data,productInfo);
              // }
            }
          }
          this.loadingPrintCode = false;
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },
      // 打印标签V2
      printCodeV2() {
        this.loadingPrintCode = true;
        this.$http.get("basic", `productionManage/printsn?id=${this.selectedRow.pkid}`).then((resp) => {
          if (resp.success) {
            if (resp.data.length) {
              this.$refs.materialCodeModal3.open(resp.data, this.selectedRow);
            }
          }
          this.loadingPrintCode = false;
        }).catch(() => {
          this.loadingPrintCode = false;
        });
      },


    },
  };
</script>
<style lang="scss" scoped>
</style>
